import {IProbeCall, IProbePhase} from './types'

// 리포트 전체/개별 바디를 클립보드로. utils/etc의 copyToClipboard는 복사한 문자열을 통째로 alert하는데,
// raw 바디는 수십 KB라 그대로 쓰면 화면을 덮는다. 여기서는 짧은 확인 문구만 띄운다.
export const copyProbeText = async (text: string, label: string) => {
    try {
        await navigator.clipboard.writeText(text)
        alert(`${label} 복사됨`)
    } catch (e: any) {
        alert(`복사 실패: ${e?.toString()}`)
    }
}

export const formatProbeTime = (at?: string) => {
    if (!at) return '-'
    const date = new Date(at)
    if (isNaN(date.getTime())) return at
    return date.toLocaleString()
}

// 호출 바디를 화면에 붙일 문자열로. JSON이면 들여쓰기, 아니면 raw_text 그대로.
export const callBodyText = (call: IProbeCall) => {
    if (call.raw !== undefined && call.raw !== null) {
        try {
            return JSON.stringify(call.raw, null, 2)
        } catch {
            return String(call.raw)
        }
    }
    return call.raw_text || ''
}

// 한 호출이 "문제 있는 응답"인지. HTTP는 200인데 바디 안에서 거래소가 거절하는 경우가 흔해서
// 상태 코드만으로는 못 거른다 — transport 에러, 4xx/5xx, 그리고 바디의 에러 문구까지 같이 본다.
export const isFailedCall = (call: IProbeCall) => {
    if (call.error) return true
    if (call.http_status >= 400 || call.http_status === 0) return true
    const body = callBodyText(call).toLowerCase()
    if (!body) return false
    return /permission|invalid|denied|unauthor|forbidden|signature|expired|"?msg"?\s*:\s*"(?!success)/.test(body)
}

export const isFailedPhase = (phase: IProbePhase) => !!phase.error

// phase 한 줄 요약. ran/unsupported/note 조합을 매번 화면에서 풀어 쓰지 않도록 여기로 모은다.
export const phaseStateLabel = (phase: IProbePhase) => {
    if (phase.error) return 'Failed'
    if (phase.unsupported) return 'Unsupported'
    if (phase.ran) return 'OK'
    return 'Skipped'
}
